import {TSpacer} from '@/common/types'

import styles from './Spacer.module.scss'

const Spacer = ({height = 0}: TSpacer): JSX.Element => {
  return <section className={styles.section} style={{height: `${height}px`}}></section>
}

export default Spacer
